"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyReportsWeeklyTrapCatches = void 0;
const zod_1 = require("zod");
exports.legacyReportsWeeklyTrapCatches = zod_1.z.object({
    reportIds: zod_1.z.array(zod_1.z.string()).optional(),
    includeDeleted: zod_1.z.boolean().default(false).optional(),
    attributes: zod_1.z
        .object({
        createdAt: zod_1.z.literal(true).optional(),
        updatedAt: zod_1.z.literal(true).optional(),
        deletedAt: zod_1.z.literal(true).optional(),
        reportId: zod_1.z.literal(true).optional(),
        name: zod_1.z.literal(true).optional(),
        notifyOwnerByEmail: zod_1.z.literal(true).optional(),
        contacts: zod_1.z
            .object({
            contactId: zod_1.z.literal(true).optional(),
            email: zod_1.z.literal(true).optional(),
            language: zod_1.z.literal(true).optional(),
            name: zod_1.z.literal(true).optional(),
            sms: zod_1.z.literal(true).optional(),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).length, {
            message: "Must request at least one attribute of the report's contacts",
        }),
        groups: zod_1.z
            .object({
            groupId: zod_1.z.literal(true).optional(),
            name: zod_1.z.literal(true).optional(),
            contactsForGroup: zod_1.z
                .object({
                contactId: zod_1.z.literal(true).optional(),
                email: zod_1.z.literal(true).optional(),
                language: zod_1.z.literal(true).optional(),
                name: zod_1.z.literal(true).optional(),
                sms: zod_1.z.literal(true).optional(),
            })
                .optional()
                .refine((args) => !args || !!Object.keys(args || {}).length, {
                message: "Must request at least one attribute of the report's groups' contacts",
            }),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).length, {
            message: "Must request at least one attribute of the report's groups",
        }),
        dayOfWeek: zod_1.z.literal(true).optional(),
        propertyIds: zod_1.z.literal(true).optional(),
        startDate: zod_1.z.literal(true).optional(),
        endDate: zod_1.z.literal(true).optional(),
        rules: zod_1.z.literal(true).optional(),
    })
        .optional()
        .refine((args) => !args || !!Object.keys(args || {}).length, {
        message: 'Must request at least one attribute for the report if specifying any at all',
    }),
});
//# sourceMappingURL=legacyReportsWeeklyTrapCatches.js.map